import { accountConfig } from "@account/configs";
import { evaluateConfig } from "@crystal/core";
import { createGlassHttp } from "@crystal/glass-bridge";
import { getToken } from "@crystal/recaptcha";
import { getExternalTouchpointParameters } from "../config/external-parameters.js";
import "../config/presets.js";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import { getRuntimeInfo } from "../integration/state-getters.js";
import "./email-detection.js";
import "@crystal/http";
import { FrontendName } from "../monitoring.js";
import { GenericError } from "./user-types.js";
import "../ap2/config.js";
import "../ap2/state.js";
import "@crystal/analytics";
import "../external-auth/config.js";
import "@crystal/config";
import "../config/source-ids.js";
async function getProfileData() {
  const { get } = createGlassHttp({
    clientTag: FrontendName
  });
  try {
    const { profile } = await get("/api/account/profile");
    return profile;
  } catch (err) {
    const error = new GenericError(err, {
      details: err
    });
    return Promise.reject(error.serialize());
  }
}
async function reloadSession() {
  const { get } = createGlassHttp({
    clientTag: FrontendName
  });
  try {
    return await get("/api/account/basic-profile");
  } catch (err) {
    const error = new GenericError(err, {
      details: err
    });
    return Promise.reject(error.serialize());
  }
}
async function logout() {
  const { post } = createGlassHttp({
    clientTag: FrontendName
  });
  try {
    return await post("/api/account/logout");
  } catch (err) {
    const error = new GenericError(err, {
      details: err
    });
    return Promise.reject(error.serialize());
  }
}
async function startPasswordReset(email) {
  const { post } = createGlassHttp({
    clientTag: FrontendName
  });
  const externalParams = getRuntimeInfo().isAuthProvider ? getExternalTouchpointParameters() : void 0;
  const { recaptchaSiteKey } = evaluateConfig(accountConfig);
  const body = {
    email,
    recaptcha: await getToken(recaptchaSiteKey, {
      action: "password_reset"
    }),
    sourceId: externalParams == null ? void 0 : externalParams.sourceId
  };
  try {
    return await post("/api/account/password-reset/start", body);
  } catch (err) {
    const error = new GenericError(err, {
      details: err
    });
    return Promise.reject(error.serialize());
  }
}
const userApi = {
  reloadSession,
  logout,
  startPasswordReset,
  getProfileData
};
export {
  userApi
};
//# sourceMappingURL=user.js.map
